import { Link } from 'react-router-dom';

export const Wordmark = ({ className = '' }) => (
  <Link to="/" className={`inline-flex items-baseline gap-2 ${className}`} data-testid="brand-wordmark">
    <span className="font-display text-2xl md:text-[1.75rem] leading-none text-[color:var(--pd-text)]">The Padel Draw</span>
    <span className="font-mono text-[10px] text-muted-sage hidden md:inline">Est. 2026</span>
  </Link>
);

export default Wordmark;
